"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spellActionSchema = void 0;
var joi = __importStar(require("joi"));
var geo_1 = require("../geo");
var checksum_1 = require("./checksum");
var spell_1 = require("./spell");
exports.spellActionSchema = joi.object({
    spellId: spell_1.spellIdSchema,
    targetPos: geo_1.positionSchema,
    launchTime: joi.number().required().integer().min(0),
    duration: joi.number().required().integer().min(0),
    checksum: checksum_1.checksumSchema
});
